import React, { useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
    Button,
    TextField,
    LinearProgress
 } from '@material-ui/core';

import { ReportProvider, ReportContext } from './ReportContext';
import { NavContext, NavRoutes, UserContext, ToastContext } from '../../../contexts';

// Enable accordingly
// import {     
// } from './components';

// Looking for an icon name?
// look here! https://material-ui.com/components/material-icons/
//import from '@material-ui/icons/'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    reportContainer: {
        textAlign: 'center',
        marginTop: '50px'
    },
    reportName: {
        fontSize: '20px',
        fontWeight: 600
    },
    reportUrl: {
        fontSize: '1rem',
        margin: '50px 0px'
    },
    reportDescription: {
        fontSize: '1rem',
        marginBottom: '60px'
    },
    editField: {
        width: "400px",
        margin: '0px 20px 10px'
    },
    editLinkContainer: {
        margin: '50px 0px'
    },
    editDescriptionContainer: {
        marginBottom: '50px'
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    editButtonContainer: {
        marginRight: '15px'
    },
    updateButtonContainer: {
        marginRight: '15px'
    },
    deleteButtonContainer: {
        marginLeft: '15px'
    },
    cancelButtonContainer: {
        marginLeft: '30px'
    },
    buttonSize: {
        fontSize: '12px'
    }
});

const PageContent = (props) => {
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
    const classes = useStyles();

    const {
        showSuccessMessage,
        showWarningMessage,
        showErrorMessage
      } = useContext(ToastContext);

    const {
        navigateTo
    } = useContext(NavContext)

    const {
        state,
        getReportAsync,
        deleteReportAsync
      } = useContext(ReportContext);
    
    const {
        isLoadingReports,
        currentReport
    } = state;

    const {
        updateReportAsync,
        updatedReport
	} = useContext(UserContext);

    const { reportId } = useParams();
    useEffect(() => {
        getReportAsync(reportId);
    }, [reportId])

    const [report, setReport] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [reportName, setReportName] = useState(null);
    const [reportUrl, setReportUrl] = useState(null);
    const [reportDescription, setReportDescription] = useState(null);
    useEffect(() => {
        if (currentReport !== null){
            setReport(currentReport);

            if (updatedReport !== null)
                setReport(updatedReport);
        }
    }, [currentReport, updatedReport])

    useEffect(() => {
        if (report !== null){
            addBreadcrumbToken(report.name);
            setReportName(report.name);
            setReportUrl(report.reportUrl);
            setReportDescription(report.description);
            setEditMode(false);
        }
    }, [report])

    return (
        <div>
            {isLoadingReports ?
            <LinearProgress color="primary" /> :
            <div className={classes.reportContainer}>
                {report &&
                <div>
                    {!editMode ?
                    <div>
                        <div className={classes.reportName}>
                            {report.name}
                        </div>
                        <div className={classes.reportUrl}>
                            {report.reportUrl}
                        </div>
                        <div className={classes.reportDescription}>
                            {report.description}
                        </div>
                    </div> :
                    <div>
                        <div>
                            <TextField
                                label="Title"
                                variant="outlined"
                                className={classes.editField}
                                value={reportName ? reportName : ""}
                                onChange={event => {
                                    event.persist();
                                    setReportName(event.target.value);
                                }}
                            />
                        </div>
                        <div className={classes.editLinkContainer}>
                            <TextField
                                label="PowerBI link"
                                variant="outlined"
                                className={classes.editField}
                                value={reportUrl ? reportUrl : ""}
                                onChange={event => {
                                    event.persist();
                                    setReportUrl(event.target.value);
                                }}
                            />
                        </div>
                        <div className={classes.editDescriptionContainer}>
                            <TextField
                                label="Description"
                                variant="outlined"
                                multiline
                                rowsMax="4"
                                className={classes.editField}
                                value={reportDescription ? reportDescription : ""}
                                onChange={event => {
                                    event.persist();
                                    setReportDescription(event.target.value);
                                }}
                            />
                        </div>
                    </div>
                    }
                    <div className={classes.buttonsContainer}>
                        {!editMode ?
                        <div className={classes.editButtonContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.buttonSize}
                                onClick={() => setEditMode(true)}
                            >
                                Edit
                            </Button>
                        </div>
                        :
                        <div className={classes.updateButtonContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.buttonSize}
                                onClick={() => {
                                    if (reportName && reportUrl && reportDescription){
                                        const newData = {
                                            reportLinkId: report.reportLinkId,
                                            name: reportName,
                                            reportUrl: reportUrl,
                                            description: reportDescription
                                        };

                                        updateReportAsync(newData);
                                    }
                                    else 
                                        showErrorMessage("Enter each field to continue");
                                }}
                            >
                                Update
                            </Button>
                        </div>
                        }
                        <div className={classes.deleteButtonContainer}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.buttonSize}
                                onClick={() => {
                                    if (window.confirm("Are you sure you want to delete this report?"))
                                        sendDataAsync();

                                    async function sendDataAsync(){
                                        await deleteReportAsync(report.reportLinkId);
                                        navigateTo(NavRoutes.Admin.Reports, []);
                                    }
                                }}
                            >
                                Delete
                            </Button>
                        </div>
                        <div className={classes.cancelButtonContainer}>
                            <Button
                                variant="contained"
                                className={classes.buttonSize}
                                onClick={() => {
                                    if (editMode){
                                        setEditMode(false);
                                        setReportName(report.name);
                                        setReportUrl(report.reportUrl);
                                        setReportDescription(report.description);
                                    }
                                    
                                    else
                                        navigateTo(NavRoutes.Admin.Reports, []);
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
    );
}

export const ReportPage = () => {

    return (
        <ReportProvider>
            <PageContent />
        </ReportProvider>
    );
}